function generateColorOptions(element, count, price) {
        // Remove existing color options
        document
          .querySelectorAll(".color-options")
          .forEach((el) => el.remove());

        // Update hidden input field for selected price
        document.getElementById("selected_price").value = price;

        // Check if this option should have color selections
        const hasColor = element.dataset.hasColor === "true";

        if (!hasColor) return; // Skip color generation if not required

        // Create and display color options
        const colorDiv = document.createElement("div");
        colorDiv.classList.add("color-options");

        for (let i = 1; i <= count; i++) {
          const label = document.createElement("label");
          label.innerHTML = `#${i} 
              <select name="color${i}" class="color-select">
                  <option value="Black">Black</option>
                  <option value="Teal">Teal</option>
                  <option value="White">White</option>
              </select>`;
          colorDiv.appendChild(label);
          colorDiv.appendChild(document.createElement("br"));
        }

        // Append color options under the selected option box
        element.parentNode.appendChild(colorDiv);
      }

      window.onload = function () {
        const defaultOption = document.querySelector(
          'input[value="Buy 3 + Get 2"]'
        );
        generateColorOptions(defaultOption, 5, 74.97);
      };

      document
        .getElementById("orderForm")
        .addEventListener("submit", function (event) {
          let colorInputs = document.querySelectorAll(".color-select");
          let urlParams = new URLSearchParams(new FormData(this));

          // Append color values only if any exist
          if (colorInputs.length > 0) {
            colorInputs.forEach((select, index) => {
              urlParams.append(`color${index + 1}`, select.value);
            });
          }

          event.preventDefault();
          window.location.href = this.action + "?" + urlParams.toString();
        });